var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDataManage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 2C4.686 2 2 3.343 2 5V12C2 13.657 4.686 15 8 15C11.314 15 14 13.657 14 12V5C14 3.343 11.314 2 8 2ZM8 3.333C10.577 3.333 12.667 4.224 12.667 5C12.667 5.776 10.577 6.667 8 6.667C5.423 6.667 3.333 5.776 3.333 5C3.333 4.224 5.423 3.333 8 3.333ZM3.333 6.822C4.162 7.443 5.94 7.833 8 7.833C10.06 7.833 11.838 7.443 12.667 6.822V8.156C12.667 8.932 10.577 9.822 8 9.822C5.423 9.822 3.333 8.932 3.333 8.156V6.822ZM3.333 9.989C4.162 10.61 5.94 11 8 11C10.06 11 11.838 10.61 12.667 9.989V11.322C12.667 12.098 10.577 12.989 8 12.989C5.423 12.989 3.333 12.098 3.333 11.322V9.989Z",
    fill: "#1F242E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDataManage);
export default __webpack_public_path__ + "static/media/dataManage.f2fb0507765c0980f80a41f31722d7f8.svg";
export { ForwardRef as ReactComponent };